import { HelpdeskBantuanDataMapper } from '../../../data/mappers/HelpdeskBantuan';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { HelpdeskBantuanRepositoryInterface } from '../../../data/contracts/HelpdeskBantuan';
import { HelpdeskBantuan } from '../../../entities/HelpdeskBantuan';

export class HelpdeskBantuanApiRepository
  implements HelpdeskBantuanRepositoryInterface
{
  private apiService: ApiService;
  private mapper: HelpdeskBantuanDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: HelpdeskBantuanDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllHelpdeskBantuan(
    page: number,
    rows: number,
    keyword: string
  ): Promise<HelpdeskBantuan[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.helpdeskBantuan(),
      {
        page: page,
        rows: rows,
        keyword: keyword,
      },
      null,
      headers
    );
    return this.mapper.convertListHelpdeskBantuan(dataResponse);
  }

  public async updateHelpdeskBantuan(
    id: number,
    tanggapan: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    let formData = new FormData();
    formData.append('tanggapan', tanggapan.toString());
    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.helpdeskBantuan() + '/' + id,
      null,
      formData,
      headers
    );
    return dataResponse;
  }

  public async deleteHelpdeskBantuan(id: number): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'delete',
      this.endpoints.helpdeskBantuan() + '/' + id,
      {},
      null,
      headers
    );
    return dataResponse;
  }
}
